<template>
    <div class="ProfileViewFragment">
        <section class="ProfileView">
            <ProfileDetails />
            <Divider />
            <Container v-show="false">
                <div class="ProfileView__gawp--permissions">
                    <div class="permission-header">
                        <h3 class="permission-header__typography">Permissions:</h3>
                    </div>
                    <ul class="permissions-list">
                        <li class="permissions-list__name">
                            <code>user.settings.themes.GoldPremiumTheme</code>
                        </li>
                        <li class="permissions-list__name">
                            <code>user.settings.themes.GoldPremiumTheme</code>
                        </li>
                        <li class="permissions-list__name">
                            <code>user.settings.themes.GoldPremiumTheme</code>
                        </li>
                        <li class="permissions-list__name">
                            <code>user.settings.themes.GoldPremiumTheme</code>
                        </li>
                        <li class="permissions-list__name">
                            <code>user.settings.themes.GoldPremiumTheme</code>
                        </li>
                    </ul>
                </div>
            </Container>
        </section>
        <!-- PROFILE SETTINGS SECTION -->
        <section class="ProfileViewSettings">
            <div class="ProfileViewSettings__header">
                <h3 class="ProfileViewSettings__header--typography">{{ $l("platon.security-title", "Хавфсизлик") }}</h3>
            </div>
            <Container class="ProfileViewSettings__details">
                <Accordion
                    icon="mdi mdi-lock-reset"
                    :header="$l('platon.change-password-title', 'Парольни ўзгартириш')"
                    :disabled="isChangePasswordDisabled"
                >
                    <PasswordSettingsSection />
                </Accordion>
                <Accordion
                    icon="mdi mdi-shield-edit"
                    :header="$l('platon.otp-enable', 'OTP-ни ёқиш')"
                    :disabled="isOtpDisabled"
                >
                    <MFASection />
                </Accordion>
                <Accordion icon="mdi mdi-key" header="E-imzo" :disabled="isEimzoDisabled">
                    <SignatureSection />
                </Accordion>
            </Container>
        </section>
    </div>
</template>

<script>
import Container from "./components/container"
import Divider from "./components/divider"
import Accordion from "./components/accordion"
import PasswordSettingsSection from "./sections/PasswordSettingsSection"
import SignatureSection from "./sections/SignatureSection"
import MFASection from "./sections/MFASection"
import ProfileDetails from "./sections/ProfileDetails"
import { IS_OTP_DISABLED, IS_EIMZO_DISABLED, IS_CHANGE_PASSWORD_DISABLED } from "@Platon/const"

import ModalVerification from "./components/xModal"
export default {
    name: "ProfileView",
    props: {},
    data() {
        return {
            isOtpDisabled: IS_OTP_DISABLED,
            isEimzoDisabled: IS_EIMZO_DISABLED,
            isChangePasswordDisabled: IS_CHANGE_PASSWORD_DISABLED
        }
    },
    components: {
        Container,
        Divider,
        Accordion,
        PasswordSettingsSection,
        MFASection,
        ProfileDetails,
        SignatureSection,

        // #temp
        ModalVerification
    },
    mounted() {
        // this.$modal.show(
        //     Modal,
        //     { width: "400px", clickToClose: false }
        // )
    }
}
</script>

<style lang="scss" scoped>
@import "./profileDetails.scss";
</style>
